<template>
    <Header>
        <template v-slot:title>
            <h1>{{ $e('Your Logs') }}<a href="https://optimizelink.com/flow/logs" class="opui-headline-helplink opui-fa opui-fa-question-circle-o" target="_blank"></a></h1>
        </template>

        <template v-slot:right-menu-buttons>
            <button class="opui-btn opui-btn-primary" @click="refreshLogs">
                {{ $e('Refresh Logs') }}
            </button>

            <button class="opui-btn opui-btn-danger opui-ml-4" @click="clearLogs">
                {{ $e('Clear Logs') }}
            </button>
        </template>
    </Header>
    <Transition>
        <main class="opui-main opui-pt-7">
            <div class="opui-container opui-max-1200">
                <div v-if="err"><ErrorBar :err="err" /></div>

                <div class="opui-d-flex opui-justify-content-between" v-if="loaded">
                    <div class="opui-d-flex">
                        <select class="opui-form-control opui-mr-3" @change="refreshLogs" v-model="logTime">
                            <option value="all">{{ $e('All entries') }}</option>
                            <option value="7">{{ $e('Last 7 days') }}</option>
                            <option value="14">{{ $e('Last 14 days') }}</option>
                            <option value="30">{{ $e('Last 14 days') }}</option>
                        </select>

                        <!--<select class="opui-form-control" @change="refreshLogs" v-model="logTime">
                            <option value="all">All statuses</option>
                            <option value="success">Successful</option>
                            <option value="delay">Delayed</option>
                            <option value="error">Error</option>
                        </select>-->
                    </div>

                    <div class="opui-d-flex opui-justify-content-between">
                        <div>
                            {{ $e('Store up to') }}
                            <input type="number" class="opui-form-control opfl-log-entry-num" v-model="this.settingsStore.maxLogItems" @change="saveMaxLogItems">
                            {{ $e('log entries') }}
                        </div>
                    </div>
                </div>

                <table class="opui-advanced-table" v-if="loaded && rows && rows.length" :class="{ 'opfl-table-is-refreshing': refreshing }">
                    <thead>
                        <tr>
                            <th>{{ $e('Workflow') }}</th>
                            <th class="opui-text-truncate" style="max-width: 250px;">{{ $e('Date/Time') }}</th>
                            <th>{{ $e('Status') }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in rows" :key="row.id">
                            <td>
                                <i class="opfl-status-indicator opui-fa opui-fa-clock-o      opfl-status-indicator-delayed" v-if="row.status      === 'delayed'"></i>
                                <i class="opfl-status-indicator opui-fa opui-fa-times        opfl-status-indicator-error"   v-else-if="row.status === 'error'"></i>
                                <i class="opfl-status-indicator opui-fa opui-fa-check-circle opfl-status-indicator-success" v-else-if="row.status === 'success'"></i>
                                {{ row.workflow_title }}<br>
                                <!-- <small>{{ row.type }}</small> /
                                <small>{{ row.workflow_run_uid }}</small>
                                <ul v-if="row.items" class="opui-ml-4">
                                    <li v-for="item in row.items">
                                        <small>{{ item.title}} - {{ item.type }} / {{ item.status }}</small>
                                    </li>
                                </ul> -->
                            </td>
                            <td>{{ row.created_at }}</td>
                            <td style="width: 40%">
                                <span v-for="status in row.status_items" class="opui-badge opfl-status-badge" :class="'opui-badge-' + status.status_class">
                                    {{ status.text }}
                                </span>

                                <p v-if="row.status === 'error'"><small>{{ $e('Workflow terminated.') }}</small></p>
                                <p v-else-if="row.is_delayed"><small>{{ $e('Workflow is delayed.') }}</small></p>
                                <p v-else><small>{{ $e('Workflow finished successfully.') }}</small></p>
                            </td>
                            <td class="opui-table-actions opui-text-right opui-text-nowrap">
                                <a @click.prevent="showDetails(row)" class="opui-btn opui-btn-link opui-btn-small opui-btn-mini opui-m-r-2"><i class="opui-icon-zoom-plus"></i></a>
                                <a @click.prevent="deleteRow(row)" class="opui-btn opui-btn-link opui-btn-small opui-btn-mini opui-m-r-2"><i class="opui-icon-trash"></i></a>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot v-if="totalPages > 1">
                        <tr>
                            <th scope="row" colspan="6">
                                <div class="opui-flex opui-justify-content-between">
                                    <div>
                                        {{ $e('Showing') }}
                                        {{ rows.length }}
                                        {{ $e('of') }}
                                        {{ totalItems }}
                                        {{ $e('items') }}
                                    </div>

                                    <ul class="opui-pagination opui-justify-content-center" v-if="totalPages > 1">
                                        <li class="opui-page-item" :class="{ disabled: (currentPage <= 1) }">
                                            <a class="opui-page-link" @click.prevent="prevPage">‹</a>
                                        </li>
                                        <li class="opui-page-item" :class="{ active: index === currentPage }" v-for="index in pagination">
                                            <span v-if="index === '...'" style="position: relative; top: 7px;" class="opui-mx-2">...</span>
                                            <a class="opui-page-link" v-else href="#" @click.prevent="goToPage(index)">{{ index }}</a>
                                        </li>
                                        <li class="opui-page-item" :class="{ disabled: (currentPage >= totalPages) }">
                                            <a class="opui-page-link" @click.prevent="nextPage">›</a>
                                        </li>
                                    </ul>
                                </div>
                            </th>
                        </tr>
                    </tfoot>
                </table>

                <div v-else-if="loaded">
                    <div class="opui-alert opui-alert-dismissible opui-alert-warning opui-mt-4">
                        <h4 class="opui-alert-heading">No log entries found.</h4>
                    </div>
                </div>
            </div>
        </main>
    </Transition>
</template>

<script>
import { useSettingsStore } from "../store/settings"
import { mapStores } from 'pinia'
import ErrorBar from "../components/Global/ErrorBar.vue"
import Header from "../components/Global/Header.vue"
import ListItem from "../components/Workflows/ListItem.vue"
import ItemListIsLoading from "../components/Loading/ItemListIsLoading.vue"
import DeleteModal from "../components/Logs/DeleteModal.vue"
import DetailsModal from "../components/Logs/DetailsModal.vue"
import ConfirmModal from "../components/Global/ConfirmModal.vue";

export default {
    components: { DeleteModal, DetailsModal, ErrorBar, Header, ListItem, ItemListIsLoading },
    data() {
        return {
            loaded:          false,
            rows:            [],
            err:             {},
            logTime:         'all',
            totalPages:       0,
            totalItems:       0,
            currentPage:      1,
            refreshing:      false,
            refreshInterval: false,
        }
    },
    computed: {
        ...mapStores(useSettingsStore),

        /**
         * Create indexes for pagination
         * @returns {*[]}
         */
        pagination() {
            let pages       = []
            let onSides     = 1
            let currentPage = this.currentPage
            let totalPages  = this.totalPages

            // Loop through
            for (let i = 1; i <= totalPages; i++) {
                // Define offset
                let offset = (i === 1 || totalPages) ? onSides + 1 : onSides

                // If added
                if (i === 1 || (currentPage - offset <= i && currentPage + offset >= i) ||
                    i === currentPage || i === totalPages) {
                    pages.push(i);
                } else if (i === currentPage - (offset + 1) || i === currentPage + (offset + 1)) {
                    pages.push('...');
                }
            }

            // Add to collection
            return pages
        },
    },
    mounted() {
        this.loadInitialData()
        
        // Setup auto update for log
        setTimeout(() => {
            this.refreshInterval = setInterval(() => {
                this.refreshLogs(false)
            }, 20000)
        }, 20000)

    },
    unmounted() {
        clearInterval(this.refreshInterval)
    },
    methods: {
        /**
         * Load log rows
         * @returns {Promise<void>}
         */
        async loadInitialData(options) {
            try {
                // Calculate the page
                let page = options ? parseInt(options.page) : 1

                let response = await this.$http.get('flow/logs?time=' + this.logTime + '&page=' + page)
                let status   = await response.status
                
                if (status === 200) {
                    this.rows        = await response.data.data.rows
                    this.totalPages  = await response.data.data.total_pages
                    this.totalItems  = await response.data.data.total_items
                    this.currentPage = await response.data.data.current_page
                    this.err         = false
                } else {
                    console.error('Error when fetching logs.', response.data)
                }
            } catch (err) {
                this.err = err
            }

            this.refreshing = false
            this.loaded     = true
        },

        /**
         * Simply refresh the log view
         * @param showLoader
         */
        refreshLogs(showLoader = true) {
            if (showLoader) {
                this.refreshing  = true
            }

            this.loadInitialData()
        },

        /**
         * Got to previous page of search results
         */
        prevPage() {
            let page = this.currentPage - 1
            if (page < 1) page = 1
            this.goToPage(page)
        },

        /**
         * Got to next page of search results
         */
        nextPage() {
            let page = this.currentPage + 1
            if (page > this.totalPages) page = this.totalPages
            this.goToPage(page)
        },

        /**
         * Got to specific page of search results
         * @param page
         */
        goToPage(page) {
            this.refreshing = true
            this.loadInitialData({ page: page, })
        },

        showDetails(row) {
            this.$vfm.show({ component: DetailsModal, bind: { row: row } })
        },

        deleteRow(row) {
            let that = this

            this.$vfm.show({
                component: ConfirmModal,
                bind: { title: 'Delete Log Row', text: 'Are you sure you want to delete this log row?' },
                on: {
                    async confirm(close) {
                        let response = await that.$http.post('flow/logs/delete/' + row.id)
                        let status   = await response.status

                        if (status === 200) {
                            that.refreshLogs(false)
                            that.$toast.success('Log deleted.')
                        } else {
                            console.info('Error when deleting log.', response.data)
                        }
                        close()
                    },
                    cancel(close) {
                        close()
                    }
                }
            })
        },

        /**
         * Clear out log table
         * @returns {Promise<void>}
         */
        async clearLogs() {
            if (confirm('Are you sure?')) {
                try {
                    let response = await this.$http.post('flow/logs/clear')
                    let status = await response.status

                    if (status !== 200) {
                        console.error('Error when clearing logs.', response.data)
                    } else {
                        this.refreshLogs();
                    }
                } catch (err) {
                    this.err = err
                }
            }
        },

        async saveMaxLogItems() {
            let response = await this.$http.post('flow/logs/max-items', {
                items: this.settingsStore.maxLogItems
            })
            let status = await response.status

            if (status !== 200) {
                console.error('Error when saving max log items.', response.data)
            }
        }
    }
}
</script>

<style scoped>
.opfl-status-badge {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 200px;
    margin-right: 8px;
    margin-bottom: 5px;
}

.opfl-status-indicator {
    opacity: .7 !important;
}
.opfl-status-indicator-delayed {
    color: #ffc105 !important;
}
.opfl-status-indicator-error {
    color: #dc3848 !important;
}
.opfl-status-indicator-success {
    color: #09903d !important;
}

.opfl-log-entry-num {
    display: inline-block !important;
    max-width: 100px;
}

.opfl-table-is-refreshing {
    opacity: .5;
}


.v-enter-active,
.v-leave-active {
    transition: opacity 0.1s ease-in-out;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
